import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './menu.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { classMap } from 'lit/directives/class-map.js'


export const menuLayouts = ['inline', 'vertical'] as const
export type menuLayoutType = typeof menuLayouts[number]

@customElement('cse-menu')
export class CSEMenu extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String })
  layout: menuLayoutType = 'vertical'

  @property({ type: String, attribute: 'layout-mobile' })
  layoutMobile: menuLayoutType = 'inline'

  override render() {
    const classes = classMap({
      'cse-menu': true,
      'layout-inline': this.layout === 'inline',
      'layout-mobile-inline': this.layoutMobile === 'inline',
      'layout-mobile-vertical': this.layoutMobile === 'vertical',
    })

    return html`
      <div class="${classes}">
        <slot></slot>
      </div>
    `
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'cse-menu': CSEMenu
  }
}
